import React from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../libs/shared/core/src/helpers/internationalization/react';
import {fontSizes, fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';
import {DepartmentsEnum} from '../../../models/api/userMetadataModel';

/*
 * Common props.
 */

export interface SlidesCommonProps {
  stepNumber: number;
  totalStepCount: number;
}

/*
 * Constants.
 */

export const newOnboardingSlideWidth = '1084px';
export const newOnboardingSlideHeight = '692px';

/*
 * Style.
 */

export const StyledOnboardingFormTitlesDiv = styled.div`
  margin-bottom: 8px;
`;

export const StyledOnboardingFormTitleDiv = styled.div`
  color: ${(p) => p.theme.greys.shade90};
  font-size: 24px;
  font-weight: ${fontWeights.bold};
  line-height: 1.25;
`;

export const StyledFormDescriptionDiv = styled.div`
  color: ${(p) => p.theme.greys.shade70};
  font-weight: ${fontWeights.medium};
  font-size: ${fontSizes.medium};
  line-height: 1.29;
  margin-bottom: 32px;
  width: 456px;
`;

export const StyledOnboardingNavSkipDiv = styled.div`
  font-weight: ${fontWeights.semibold};
  margin-inline-end: 10px;
`;

/*
 * Helper functions.
 */

export const TeamsItems = [
  {
    title: computeDisplayNameForTeam(DepartmentsEnum.CUSTOMER_SUPPORT),
    key: DepartmentsEnum.CUSTOMER_SUPPORT,
  },
  {
    title: computeDisplayNameForTeam(DepartmentsEnum.CLIENT_SERVICES),
    key: DepartmentsEnum.CLIENT_SERVICES,
  },
  {
    title: computeDisplayNameForTeam(DepartmentsEnum.SALES),
    key: DepartmentsEnum.SALES,
  },
  {
    title: computeDisplayNameForTeam(DepartmentsEnum.ACCOUNT_MANAGEMENT),
    key: DepartmentsEnum.ACCOUNT_MANAGEMENT,
  },
  {
    title: computeDisplayNameForTeam(DepartmentsEnum.EXECUTIVE),
    key: DepartmentsEnum.EXECUTIVE,
  },
  {
    title: computeDisplayNameForTeam(DepartmentsEnum.OPERATIONS),
    key: DepartmentsEnum.OPERATIONS,
  },
  {
    title: computeDisplayNameForTeam(DepartmentsEnum.BROKERAGE),
    key: DepartmentsEnum.BROKERAGE,
  },
  {
    title: computeDisplayNameForTeam(DepartmentsEnum.OTHER),
    key: DepartmentsEnum.OTHER,
  },
];

function computeDisplayNameForTeam(department?: string) {
  switch (department) {
    case DepartmentsEnum.CUSTOMER_SUPPORT:
      return <Trans id="team-customersupport">Customer Support</Trans>;
    case DepartmentsEnum.CLIENT_SERVICES:
      return <Trans id="team-clientservices">Client Services</Trans>;
    case DepartmentsEnum.SALES:
      return <Trans id="team-salesbusinessdevelopment">Sales</Trans>;
    case DepartmentsEnum.ACCOUNT_MANAGEMENT:
      return <Trans id="team-accountmanagement">Account Management</Trans>;
    case DepartmentsEnum.EXECUTIVE:
      return <Trans id="team-executive">Executive</Trans>;
    case DepartmentsEnum.OPERATIONS:
      return <Trans id="team-operations">Operations</Trans>;
    case DepartmentsEnum.BROKERAGE:
      return <Trans id="team-brokerage">Brokerage</Trans>;
    default:
      return <Trans id="team-other">Enter something else</Trans>;
  }
}

export function generateStepText(current: number, total: number) {
  return (
    <>
      {current} <Trans id="onboardingwelcome-of">of</Trans> {total}
    </>
  );
}
